// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .custom-list-item[data-v-9353285e] {\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  background-color: #f8f9fa;\r\n  border-radius: 10px;\r\n  cursor: grab;\n}\r\n", ""]);
// Exports
module.exports = exports;
